<div class="main text-center" [ngClass]="themeService.currentPalette">
  <div class="box">
    <h1>{{ 'CONGRATS.TITLE' | translate }}</h1>
    <p class="lead mt-4">{{ 'CONGRATS.SUCCESS_MESSAGE' | translate }}</p>
    <img class="congrat" src="../../../assets/icons/congratulations-icon.gif" alt="Felicidades">
    <p>{{ 'CONGRATS.REDIRECT_MESSAGE' | translate: { seconds: countdown } }}</p>
    <img src="../../assets/images/grafica2.png" alt="graff">
  </div>
</div>
